import { DrawableObject } from "./DrawableObject";
export class PrimitiveObject extends DrawableObject {
    constructMaterial(material) {
        // Deliberately empty
    }
    applyMaterial(material) {
        this.constructMaterial(material);
    }
    getScale(scale) {
        if (typeof scale === "undefined") {
            return {
                x: this.object.scale.x,
                y: this.object.scale.y,
                z: this.object.scale.z,
            };
        }
        else {
            scale.x = this.object.scale.x;
            scale.y = this.object.scale.y;
            scale.z = this.object.scale.z;
            return scale;
        }
    }
    setScale(scale) {
        this.object.scale.x = scale.x;
        this.object.scale.y = scale.y;
        this.object.scale.z = scale.z;
    }
    asScalableObject() {
        return this;
    }
    asMaterialObject() {
        return this;
    }
}
